import React, { useState, useEffect } from 'react'
import { message, Spin, Tooltip, Button, Empty, Popover, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'
import ObjectInspector from 'react-inspector'
import moment from 'moment'
import { getJobDetail, retryJob, cancelJob } from '../../../services/api/apiJobs'

function JobDetailPage(props) {
    const { jobId } = props
    const [loading, setLoading] = useState(false)
    const [jobDetail, setJobDetail] = useState({})
    const fetchDetailInfo = async (jobId) => {
        setLoading(true)
        try {
            const { success, data, message: mess } = await getJobDetail(jobId)
            if (!success) {
                throw new Error(mess)
            }
            setJobDetail(data)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!!jobId) {
            fetchDetailInfo(jobId)
        }
    }, [jobId])

    const handleRetry = async (jobId) => {
        setLoading(true)
        try {
            const { success, message: mess } = await retryJob(jobId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Job đã được chạy lại.`)
            fetchDetailInfo(jobId)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleCancelJob = async (jobId) => {
        setLoading(true)
        try {
            const { success, message: mess } = await cancelJob(jobId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Job đã được cancel.`)
            fetchDetailInfo(jobId)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const getStatusTootip = (status) => {
        let tooltipTitle = ''
        switch (status) {
            case 'success':
                tooltipTitle = moment(done_at).format('HH:mm DD/MM/YYYY')
                break;
            case 'processing':
                tooltipTitle = moment(processing_at).format('HH:mm DD/MM/YYYY')
                break;
            case 'error':
                tooltipTitle = <div>
                    {!!error &&
                        <p className='text-danger'>
                            <i class="fa fa-exclamation-circle text-danger mr-1" aria-hidden="true" />{error}
                        </p>
                    }
                    <span>{`${moment(error_at).format('HH:mm DD/MM/YYYY')}`}</span>
                </div>
                break;
            default:
                break;
        }
        return tooltipTitle
    }

    const getStatusClass = (status) => {
        let statusClass = ''
        switch (status) {
            case 'success':
                statusClass = 'badge badge-success badge-pill'
                break;
            case 'processing':
                statusClass = 'badge badge-info badge-pill'
                break;
            case 'error':
                statusClass = 'badge badge-danger badge-pill'
                break;
            default:
                statusClass = 'badge badge-secondary badge-pill'
                break;
        }
        return statusClass
    }

    const {
        _id, mimetype, retried, status, action, created_by, meta, handler, filename,
        number, system, service, created_at, update_at, processing_at, done_at,
        error, error_at, link_download,
    } = jobDetail || {}
    const { request = {} } = meta || {}
    const requestFiltered = Object.fromEntries(
        Object.entries(request)
            .filter(([key]) => !['user', 'headers'].includes(key))
    )
    const disabledBtnCancelJob = loading || ['success', 'error', 'cancelled'].includes(status)

    return (
        <div className='JobDetailPage'>
            <Link to='/jobs'>
                <h6 className='mb-0 backAction'>
                    <i class="fa fa-angle-double-left mx-1" aria-hidden="true" />Danh sách Jobs
                </h6>
            </Link>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <div>
                    <h1 className="PageTitle font-weight-bold mb-0">Chi tiết Job {number || ''}</h1>
                </div>
                <div className="RightTop">
                    <Tooltip title='Thử lại'>
                        <Button
                            className='btnRetry mx-2'
                            type={'primary'} disabled={loading || (retried >= 10) || !['success', 'error'].includes(status)}
                            style={{ height: 'unset' }}
                            onClick={() => handleRetry(_id)}
                        >
                            <i class="fa fa-retweet mr-1" style={{ fontSize: 17 }} /> Thử lại {`${retried || 0}/10`}
                        </Button>
                    </Tooltip>
                    {!!status && !['success', 'error', 'cancelled'].includes(status) &&
                        <Tooltip title='Hủy job'>
                            <Popconfirm
                                title={`Bạn có chắc chắn muốn hủy job ${number}?`}
                                placement={'bottomRight'}
                                okText='Có'
                                cancelText='Không'
                                disabled={disabledBtnCancelJob}
                                style={{ height: 'unset' }}
                                onConfirm={() => handleCancelJob(_id)}
                            >
                                <Button
                                    className='btnCancel'
                                    type={'danger'}
                                    disabled={disabledBtnCancelJob}
                                    style={{ height: 'unset' }}
                                >
                                    <i className={`fa fa-ban mr-1`} style={{ fontSize: 17 }} />
                                    Hủy job
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    }
                </div>
            </div>
            <div className="SectionInner mt-3">
                <Spin spinning={loading} tip='Data Loading...'>
                    {!!Object.keys(jobDetail).length ?
                        <div className="d-flex flex-wrap">
                            <div className="leftContent mr-4 card p-3" style={{ maxWidth: 600, minWidth: 320, minHeight: 300 }}>
                                <h5 className='font-weight-bold'>Thông tin Job</h5>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>_id:</span> <span>{_id}</span></h6>
                                <h6 className='d-flex'>
                                    <span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Trạng thái:</span>
                                    <Popover content={getStatusTootip(status)}>
                                        <div className={getStatusClass(status)} style={{ cursor: 'pointer' }}>
                                            {status}
                                        </div>
                                    </Popover>
                                </h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Handler:</span> <span>{handler}</span></h6>
                                <h6 className='d-flex'>
                                    <span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>File tải về:</span>
                                    {link_download && filename ?
                                        <a href={link_download} target='_blank'>
                                            <i className="fa fa-file-excel-o mx-1" aria-hidden="true" />{filename}
                                        </a> : '-'
                                    }
                                </h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Số lần thử lại:</span> <span>{retried || 0}</span></h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Người tạo:</span> <span>{created_by || '-'}</span></h6>
                                {created_at &&
                                    <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Created at:</span> <span>{moment(created_at).format('HH:mm DD/MM/YYYY')}</span></h6>
                                }
                                {processing_at &&
                                    <h6 className='d-flex'>
                                        <span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Processing at:</span>
                                        <span>{processing_at ? moment(processing_at).format('HH:mm DD/MM/YYYY') : ''}</span></h6>
                                }
                                {!!update_at &&
                                    <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Update at:</span> <span>{moment(update_at).format('HH:mm DD/MM/YYYY')}</span></h6>
                                }
                                {!!done_at &&
                                    <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Done at:</span> <span>{moment(done_at).format('HH:mm DD/MM/YYYY')}</span></h6>
                                }
                                {!!error_at &&
                                    <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Error at:</span> <span>{moment(error_at).format('HH:mm DD/MM/YYYY')}</span></h6>
                                }
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Hệ thống:</span> <span>{system}</span></h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Service:</span> <span>{service}</span></h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Action:</span> <span>{action}</span></h6>
                                <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Mimetype:</span> <span>{mimetype}</span></h6>
                                {!!error &&
                                    <h6 className='d-flex'><span className='font-weight-bold' style={{ minWidth: 100, marginRight: 30 }}>Error:</span> <span className='text-danger'>{error}</span></h6>
                                }

                            </div>
                            {!!Object.keys(requestFiltered).length &&
                                <div className="rightContent card p-3 mr-4" style={{ maxWidth: 600, minWidth: 320, minHeight: 300 }}>
                                    <h5 className='font-weight-bold'>Tham số</h5>
                                    <ObjectInspector
                                        depth={0}
                                        path="root.value"
                                        data={!!Object.keys(requestFiltered).length ? requestFiltered : '-'}
                                        expandLevel={3}
                                    />
                                </div>
                            }
                        </div> :
                        <div className="card p-3 w-100">
                            <Empty className='w-100' style={{ minHeight: 300 }} />
                        </div>
                    }
                </Spin>
            </div>
        </div>
    )
}

export default JobDetailPage